import React from 'react'
import styled from 'styled-components'

const MinText = styled.span`
  color: #00ade6;
`

const Separator = styled.span`
  color: ${({ theme }) => theme.colors.text.tertiary};
  margin: 0 2px;
`

interface MinMaxValueProps {
  /** Formatted min value string */
  minDisplay?: string
  /** Formatted max value string */
  maxDisplay?: string
}

/**
 * Renders a metric value with min/max color coding.
 * Min values are orange (#e65100), max values stay default dark.
 * - Single max: "0.33" (default color)
 * - Single min: "0.50" (orange)
 * - Range: "0.50 / 0.60" (orange / default)
 */
export const MinMaxValue: React.FC<MinMaxValueProps> = ({
  minDisplay,
  maxDisplay,
}) => {
  if (minDisplay && maxDisplay) {
    return (
      <>
        <MinText>{minDisplay}</MinText>
        <Separator>/</Separator>
        {maxDisplay}
      </>
    )
  }
  if (maxDisplay) {
    return <>{maxDisplay}</>
  }
  if (minDisplay) {
    return <MinText>{minDisplay}</MinText>
  }
  return null
}
